module.exports = __webpack_public_path__ + "public/images/civics.9657f18b638cedd60641d08ac6a811ce.png";